import { useRef, useState } from "react";
import Text from "./Text";
import { useIsMobile } from "./Flexbox";

const TRUNCATE_STYLE = {overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'};

const TruncatedText = props => {
    const isMobile = useIsMobile();
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    return (
        <span ref={wrapperRef} style={{position: 'relative', display: 'block', minWidth: 0}}>
            <Text
                {...props}
                title={isMobile ? undefined : props.text}
                onClick={isMobile ? () => setIsOpen(true) : props.onClick}
                style={{...TRUNCATE_STYLE, display: 'block', cursor: isMobile ? 'pointer' : props.style?.cursor, ...props.style}}
            >
                {props.text}
            </Text>
            {isOpen && (
                <>
                    <div onClick={() => setIsOpen(false)} style={{position: 'fixed', inset: 0, zIndex: 10}}/>
                    <div style={{
                        position: 'absolute', top: '100%', left: 0, marginTop: 4, zIndex: 11,
                        backgroundColor: props.popoverBackground || '#fff', color: props.color,
                        borderRadius: 6, padding: '8px 10px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        maxWidth: 240, wordBreak: 'break-word', whiteSpace: 'normal'
                    }}>
                        <Text weight={props.weight} size={props.size} color={props.color}>{props.text}</Text>
                    </div>
                </>
            )}
        </span>
    )
}

export default TruncatedText;